var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"menu",style:(_vm.styleMenu)},[_c('perfect-scrollbar',[_c('Tree',{ref:"tree",attrs:{"data":_vm.treeData,"options":_vm.treeOptions,"filter":_vm.treeFilter}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }